module.exports = __webpack_public_path__ + "static/media/East_Hall-c.24976d62.webp";